import React from "react";
import { Page, Card, Box, Text, Button } from "@shopify/polaris";

class AppBridgeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    if (error && error.message && error.message.includes("shopify global")) {
      return { hasError: true, error };
    }
    throw error;
  }

  componentDidCatch(error, errorInfo) {
    console.error("App Bridge Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Page fullWidth>
          <Card>
            <Box padding="800">
              <Text variant="headingMd" as="h2">
                App Bridge Not Available
              </Text>
              <Box paddingBlockStart="400">
                <Text variant="bodyMd" tone="subdued">
                  This app needs to be accessed through the Shopify Admin.
                </Text>
                <Box paddingBlockStart="400">
                  <Button
                    onClick={() => {
                      const urlParams = new URLSearchParams(window.location.search);
                      if (!urlParams.get("shop")) {
                        window.location.href =
                          window.location.href +
                          (window.location.href.includes("?") ? "&" : "?") +
                          "shop=your-shop.myshopify.com&host=" +
                          btoa("your-shop.myshopify.com/admin");
                      } else {
                        window.location.reload();
                      }
                    }}
                  >
                    Retry
                  </Button>
                </Box>
              </Box>
            </Box>
          </Card>
        </Page>
      );
    }

    return this.props.children;
  }
}

export default AppBridgeErrorBoundary;
